export default __webpack_public_path__ + "static/media/photo--sm--28.6b0f243a.jpg";